export default __webpack_public_path__ + "static/media/threedot.007d478d.svg";